<template lang='pug'>
  auth-layout
    #sign-up.view( v-if='referral.by' )
      bf-notice(:message='message' @close='message = ""')
      transition
        auth-body(v-show='show' key='auth-body')
          form.sign-up-form(@submit.prevent='sign_up')
            fieldset
              bf-input
                template(slot='icon')
                  img(src='/ui/email-icon.png')
                input( required type='email' :placeholder='$t("Email")' v-model='email' )

              bf-input
                template(slot='icon')
                  img(src='/ui/password-icon.png')
                input( 
                  :placeholder='$t("Password")'
                  required :type='type'  
                  v-model='password' 
                  minlength='8' 
                  title='Must contain at least 1 capital letter and 1 symbol' 
                  pattern='(?=.*?[#?!@$%^&*-+~@])(?=.*[A-Z]).{8,}'
                )
                template(slot='reveal')
                  img(v-if="type=='password'" src='/ui/eyeopen.svg' width="30" @click='showPassword')
                  img(v-else src='/ui/eyeclose.svg' width="30" @click='showPassword')  

              bf-input
                template(slot='icon')
                  img(src='/ui/password-icon.png')
                input( required :type='type' :placeholder='$t("Confirm Password")' v-model='confirm' )

              ol.rule
                li {{$t("Minimum of 8 characters")}}
                li {{$t("At least 1 capital letter and 1 symbol")}}
                li {{$t("A symbol is DEFINED as one of these characters")}}:  * # ? ! @ $ % ^ & * - + ~ @

              bf-input
                template(slot='icon')
                  img(src='/ui/referral-icon.png')
                input( type='text' :placeholder='$t("Referral ID")' :value='referral.by.username' :disabled='referred' )

              bf-flex.centered
                bf-button.large.combo.solid.submit(type='submit')
                  template(slot='text') {{ $t('Sign Up') }}
      
          bf-divider.section.borderless

          .auth-link
            span {{ $t("Already have an account?") }}
            router-link(:to="{ name: 'sign-in', params: {} }") {{ $t("Sign In") }}

          bf-divider.section.with-text.borderless

          bf-social-auth(:id='$route.params.id')

      terms-policy(v-show='show' key='terms-policy')
      auth-body.back-panel(v-show='show' key='back-panel')
</template>

<script>
  import { auth, db } from '@/main'
  import { Authenticable } from '@/mixins/authenticable'
  import AuthLayout from '@/layouts/auth'
  import AuthBody from '@/components/auth-body'
  import TermsPolicy from '@/components/terms-policy'

  import { Animatable } from '@/mixins/view'

  export default {
    name: 'sign-up-ref.view',

    mixins: [ Authenticable, Animatable ],

    components: {
      AuthLayout,
      AuthBody,
      TermsPolicy
    },

    data() {
      return {
        name: '',
        email: '',
        password: '',
        confirm: '',
        message: '',
        referred: !!this.$route.params.id,
        referral: {},
        authenticated: false,
        show: false,
        type: 'password'
      }
    },

    firestore() {
      return {
        referral: {
          ref: db.collection( 'referrals' ).doc( this.$route.params.id ),
          resolve: doc => {
            this.email = doc.to.email
            sessionStorage.setItem('referral', JSON.stringify( doc ) )
          }
        }
      }
    },

    methods: {
      sign_up() {
        const actionSettingCode = { url: 'https://app.bluefaucet.com/' }
        if ( this.confirm == this.password )
          auth.createUserWithEmailAndPassword( this.email, this.password )
          .then( doc => {
            let user = doc.user
            doc.user.sendEmailVerification(actionSettingCode).then( () => {
              db.collection( 'referrals' ).doc( this.referral.id ).update({ status: 'user' })
              if ( this.referral.type == 'recommendation' ) db.collection( 'referrals' ).doc( `${doc.user.uid}->${this.referral.by.upgraded.bid}` ).set({
                business_id: this.referral.by.upgraded.bid,
                account_id: doc.user.uid,
                on: new Date()
              })
              db.collection('accounts').doc( doc.user.uid ).set({
                user_id: doc.user.uid,
                email: doc.user.email || this.email || '',
                phone: doc.user.phoneNumber || this.phone || '',
                name: this.name || '',
                locale:  this.$i18n ? this.$i18n.locale : localStorage.getItem('locale'),
                merchant: false,
                referral: this.referral || false,
                tokens: {}
              }, {merge: true} ).then( () => 
                this.$binding( 'account', db.collection( 'accounts' ).doc( doc.user.uid ) ).then( doc =>
                  db.collection( 'favorites' ).doc( `${user.email}->${this.referral.by.upgraded.bid}` ).set({
                    account_id: user.uid,
                    uid: user.uid,
                    business_id: this.referral.by.upgraded.bid,
                    bid: this.referral.by.upgraded.bid
                  }).then( () => this.$router.push({ name: 'onboarding' }) )
                )
              )
            })
          })
          .catch( e => this.message = e )
        else
          this.message = this.$t('Password and confirmation does not match')
      },
      showPassword() {
        if( this.type == 'password') {
          this.type = 'text'
        } else {
          this.type = 'password'
        }
      }
    },

    // created() {
    //   db.collection( 'referrals' ).doc( this.$route.params.id ).get().then( doc => {
        
    //   })
    // }
  }
</script>

<style scoped lang='stylus'>
  ol
    font-size .8em
    margin-left 20px
    list-style-type lower-alpha

  #modal
    position fixed
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 99
    background rgba( 25 50 75 .55 )
    .close
      position absolute
      color white
      font-size 1.5em
      border 1px solid var(--clr-light)
      height 24px
      width 28px
      padding-bottom 4px
      display flex
      justify-content center
      border-radius 50%
      right 12px
      top 12px
    article
      width 320px
      display flex
      flex-direction column
      align-items center
      position relative
      header
        text-align center
        background var(--bg-nav)
        color white
        width 100%
        display flex
        flex-direction column
        align-items center
        padding 24px
        box-sizing border-box
        .logo
          width 150px
          display block
          margin-bottom 32px
      main
        background white
        display flex
        flex-direction column
        align-items center
        padding 24px
        p
          line-height 2

  .bf-button
    margin-top 16px
</style>
